<template>
  <Dialog
    v-model="isVisible"
    class="new-library-info-dialog transaction-fee-dialog"
    title="Transaction Fee"
    @close="close"
  >
    <div class="dialog-container">
      <div class="content-text">
        <span class="text">{{ contentText }} <a href="https://stripe.com/pricing" class="underline" target="_blank" rel="noopener noreferrer">document.</a></span>
      </div>
      <div class="flex justify-end action-row">
        <div class="btn-container">
          <LoginButton 
            type="info" 
            class="w-full"
            @click="$emit('close')"
          >
            {{ $t("OrderPage[\"Close\"]") }}
          </LoginButton>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import LoginButton from "@/views/login/components/LoginButton.vue";
import Dialog from "@/NewLibrary/Dialog.vue";

export default {
  components: {
    Dialog,
    LoginButton
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      isVisible: false,
      valueInput: "",
      contentText: this.$t("OrderPage[\"The transaction fee varies based on the selected payment method. Vibrant will cover transaction fees for wholesale amounts. However, providers are responsible for transaction fees incurred on amounts exceeding wholesale prices due to provider-set retail prices. For more details, view\"]")
    }
  },

  emits: ["close"],

  computed: {
  },

  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },   
  }
}
</script>

<style scoped>
:deep(.el-dialog.new-library-info-dialog) {
  --el-dialog-padding-primary: 0 !important;
}
.dialog-container {
  width: 100%;
  padding: 24px 40px 32px;
  margin: 0;
}

.content-text {
  margin-bottom: 24px;
}

.text {
  word-break: break-word;
  white-space: normal;
}

.action-row {
  padding-bottom: 0;
}

.btn-container {
  width: 140px;
}

a {
  color: #20A8C3;
}
</style>

<style>
.el-dialog.new-library-dialog.new-library-info-dialog.transaction-fee-dialog {
  --el-dialog-padding-primary: 0 !important;
}
</style>